import { add } from './add';
import { clear } from './clear';
import { findAll } from './findAll';
import { findById } from './findById';
import { findByHosts } from './findByHosts';
import { remove } from './remove';
import { update } from './update';

export const hostGroupActions = {
  add,
  clear,
  findAll,
  findById,
  findByHosts,
  remove,
  update,
};
